var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24'%3e %3cpath d='M0 10h24v4h-24z' /%3e%3c/svg%3e";
  export default img;